import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { LoadingSpinner } from '../LoadingSpinner';

const options = {
  className: 'tvt-notification-request-in-progress',
  type: toast.TYPE.DEFAULT,
  autoClose: false,
  closeButton: false
};

const Component = ({ title, text }) => (
  <div>
    <h1>
      <LoadingSpinner />
      {title}
    </h1>
    {text && <p>{text}</p>}
  </div>
);

Component.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string
};

Component.defaultProps = {
  title: 'Loading',
  text: null
};

export default ({ title, text, ...props }) =>
  toast(<Component title={title} text={text} />, { ...options, ...props });
